<div class="modal-body">
  <form #form="ngForm" novalidate>
    <!-- Seleção de dias da semana (oculto no modo semana) -->
    <div class="form-group" *ngIf="!modoSemana">
      <label>Dias da semana</label>
      <div class="dias-semana-container">
        <button
          type="button"
          class="btn btn-outline-primary mr-2 mb-2"
          *ngFor="let dia of diasDaSemana"
          [class.btn-primary]="diasSelecionados.includes(dia.dia)"
          [class.btn-outline-primary]="!diasSelecionados.includes(dia.dia)"
          [disabled]="horarioParaEditar"
          [class.disabled]="horarioParaEditar"
          (click)="toggleDia(dia.dia)">
          {{ dia.abreviacao }}
        </button>
      </div>
      <small class="text-danger" *ngIf="diasSelecionados.length === 0 && form.submitted">
        Selecione pelo menos um dia da semana
      </small>
      <small class="text-muted" *ngIf="horarioParaEditar">
        <i class="fa fa-info-circle"></i> Não é possível alterar o dia da semana ao editar um horário
      </small>
    </div>

    <!-- Informação do modo semana -->
    <div class="alert alert-info" *ngIf="modoSemana">
      <i class="fa fa-info-circle"></i>
      <strong>Modo Semana:</strong> Editando todos os horários da {{ getDiaSemanaDescricao() }}
    </div>

    <!-- Turnos -->
    <div class="form-group">
      <label>{{ modoSemana ? 'Turnos de funcionamento da ' + getDiaSemanaDescricao() : 'Turnos de funcionamento' }}</label>
      <div class="turnos-container">
        <div class="turno-item" *ngFor="let turno of turnos; let i = index">
          <div class="row"  >
            <div class="col-5">
              <label>Início</label>
              <kendo-timepicker  [disabled]="turno.removido"
                [(ngModel)]="turno.inicio"
                name="inicio{{i}}"  [max]="dataMaxima"
                class="form-control"
                [required]="true">
              </kendo-timepicker>
            </div>
            <div class="col-5">
              <label>Fim</label>
              <kendo-timepicker [disabled]="turno.removido"
                [(ngModel)]="turno.fim"
                name="fim{{i}}"
                class="form-control"
                [required]="true" (ngModelChange)="calculeDataMinima(turno)"
                [min]="turno.dataMinimaFim" [max]="dataMaxima">
              </kendo-timepicker>
            </div>
            <div class="col-2 d-flex align-items-end">
              <button  [hidden]="turno.removido"
                type="button"
                class="btn btn-danger btn-sm"
                (click)="removerTurno(i)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm mt-2"
        (click)="adicionarTurno()">
        <i class="fa fa-plus"></i> Adicionar Turno
      </button>
    </div>
  </form>

  <div class="alert alert-danger" *ngIf="msgErro">
    {{msgErro}}
  </div>
</div>
<div class="modal-footer">
  <div class="d-flex justify-content-between w-100">
    <div>
      <!--<button
        type="button"
        class="btn btn-danger"
        (click)="removerHorario()"
        *ngIf="horarioParaEditar && !modoSemana">
        <i class="fa fa-trash"></i> Remover Horário
      </button> -->
    </div>
    <div>

      <button type="button" class="btn btn-primary" (click)="salvar()" [disabled]="salvando">
        <i class="k-icon k-i-loading" *ngIf="salvando"></i>
        {{ salvando ? 'Salvando...' : 'Salvar' }}
      </button>

      <button type="button" class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
    </div>
  </div>
</div>
